module.exports = __webpack_public_path__ + "static/media/mq.ce45144d.svg";